import React from "react";
import { Slider } from "@alife/next";
import { formatNumber, handleTagsObj, handleCoupon, getUrlParms, convertBuyerTags } from "./utils.js";
import jsonp from "@alife/common-jsonp";
import "./index.scss";

// const loadWWJs = (url) => {
//   const script = document.createElement("script");
//   script.type = "text/javascript";
//   script.async = true;
//   script.src = url;
//   document.head.appendChild(script);
// };

// // 旺旺亮灯
// loadWWJs(`https://g.alicdn.com/aliww/ww-light-cbu/index.js?t=${Date.now()}`);

// ICON
const SHILI_ICON = "https://img.alicdn.com/imgextra/i2/O1CN01lmgxTV1MeGl7ScL9e_!!6000000001459-2-tps-156-30.png";
const CHAOGONG_ICON = "https://img.alicdn.com/imgextra/i3/O1CN01JogJYk1ZR4LauNmbM_!!6000000003190-2-tps-136-32.png";
const JGL_ICON = "https://img.alicdn.com/imgextra/i1/O1CN01YG6VRb1gMfsHRzTDa_!!6000000004128-2-tps-36-32.png";
const VIDEO_ICON = "https://img.alicdn.com/imgextra/i3/O1CN01M3FGYZ1jktfWaqg9k_!!6000000004587-2-tps-136-48.png";
const DANCING_GIF = "https://img.alicdn.com/imgextra/i1/O1CN01Min8b31DpPsCNleZn_!!6000000000265-1-tps-80-80.gif";

export default function Offer(props) {
  const { data, buyerTags } = props;
  const offer = data || {};
  const buyerIdentity = convertBuyerTags(buyerTags);
  const { showImgSlider, showDancingWW, showVideoIcon } = offer;
  const alitalkidUTF8 = encodeURIComponent(offer.loginId + "" || ""); 
  const title = offer.subject.replace(/<[/]?font.*?>/g, "");
  const urlParams = getUrlParms();

//   if (offer.imgUrl.indexOf("cbu01.alicdn.com") > -1) {
//     offer.imgUrl = `${offer.imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
//   }

  // 标签逻辑处理
  const hasCoupon = offer.marketingTagList.length > 0;
  const promotionTag = hasCoupon && handleCoupon(offer.marketingTagList);
  let { isShili, isSuperFactory, productTag, priceTag, serviceTags, isJglOffer } = handleTagsObj(offer.offerTagMap);
  serviceTags = hasCoupon ? serviceTags.slice(0, 2) : serviceTags.slice(0, 3);

  // 添加打点参数
  let cbu_ad_sessionid = "";
  let cbu_ad_adgroup_id = "";
  let trackInfo = offer.trackInfo;
  if (trackInfo && typeof trackInfo === "string") {
    trackInfo = JSON.parse(trackInfo);
  } else if (!trackInfo) {
    trackInfo = {};
  }
  cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
  cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

  const handleWWClick = (e) => {
    e.stopPropagation();
    props.wwClick && props.wwClick();
  };

  const RenderOfferImg = () => {
    const { imgUrlList } = offer;
    if (showImgSlider) {
      return (
        <div className="offer-img">
          <Slider
            arrows={false}
            autoplay
            autoplaySpeed={5000}
            draggable={false}
            dots={false}
            pauseOnHover
          >
            {imgUrlList && imgUrlList.length > 0 &&
              imgUrlList.map((img, idx) => {
                return (
                  <img
                    src={img.replace(".summ", "")}
                    className="main-img"
                    alt={title}
                    key={idx}
                  />
                );
              })}
          </Slider>
          {showVideoIcon && (
            <img className="video" src={VIDEO_ICON} />
          )}
        </div>
      );
    }
    return (
      <div className="offer-img">
        <img
          src={offer.imgUrl && offer.imgUrl.replace(".summ", "")}
          className="main-img layLoad"
          alt={title}
        />
        {showVideoIcon && <img className="video layLoad" src={VIDEO_ICON} />}
      </div>
    );
  };

  const RenderTitle = () => {
    return (
      <div className="offer-title">
        {/* 商品标 */}
        {productTag}
        <span title={title}>{title}</span>
      </div>
    );
  };

  const RenderOfferTags = () => {
    return (
      <div className="offer-tags">
        {/* 优惠券 */}
        {promotionTag}
        {/* 服务标 */}
        {serviceTags}
        {/* 跨境决策因子 */}
        {/* cpv */}
      </div>
    );
  };

  const RenderPriceInfo = () => {
    const isJiaGeLiOffer = buyerIdentity.jiaGeLi && isJglOffer && offer.price !== "价格面议";
    const priceNumArr = formatNumber(offer.price, 2);
    const hasDecimal = priceNumArr.length > 1;
    return (
      <div className="offer-price">
        {offer.price && (
          <span className="price" key="price">
            {isJiaGeLiOffer ? (<img className="jgl-icon" src={JGL_ICON} />) : (<em className="symbol">￥</em>)}
            <em className="number n-b">{priceNumArr[0]}</em>
            {hasDecimal && <em className="number n-s">.{priceNumArr[1]}</em>}
          </span>
        )}
        {/* 价格标 */}
        {priceTag}
        {(offer.saleVolume && offer.saleVolume !== "0" && (
          <span className="solt" key="solt">
            成交
            {formatNumber(offer.saleVolume, 0).join(".")}件
          </span>
        )) ||
          ""}
      </div>
    );
  };

  const RenderCompanyInfo = () => {
    const rebuyRate = (Number(offer.shopRepurchaseRate) * 100).toFixed();
    const tag = [];
    if (isSuperFactory) {
      tag.push(<img className="shop-icon" key="icon1" src={CHAOGONG_ICON} />);
    } else if (isShili) {
      tag.push(<img className="shop-icon h14" key="icon2" src={SHILI_ICON} />);
    } else {
      tag.push(
        <span className="name" title={offer.company} key="company-info">
          {offer.company}
        </span>
      );
    }
    return (
      <div className="offer-company">
        {tag}
        <div className="right-info">
          <span className="rebuy-rate">
            {rebuyRate !== "0" && !!offer.shopRepurchaseRate &&`回头率${rebuyRate}%`}
          </span>
          <div className="common-wangwang-tag" onClick={handleWWClick}>
            <span
              className="J_WangWang"
              data-nick={alitalkidUTF8}
              data-encode="true"
              data-icon="static"
              data-from="cnalichn"
              data-display="inline"
            />
          </div>
        </div>
        {showDancingWW && <img className="on-line" src={DANCING_GIF} />}
      </div>
    );
  };

  return (
    <div className="new_ui_offer offer_item">
      <a href={offer.eurl ? offer.eurl : offer.odUrl} target="_blank">
        {RenderOfferImg()}
        {RenderTitle()}
        {RenderPriceInfo()}
        {RenderOfferTags()}
        {RenderCompanyInfo()}
      </a>
      {
        urlParams._debugMode_ == 1 &&
        <div className="debug">{offer.debugMark}-{offer.itemType}</div>
      }
    </div>
  );
}
